/* =========================================================
   SHENHAIEX THEME — global JS
   Quick add to cart, cart count sync, toast, menu drawer, newsletter
   Works with both AJAX and native form submit fallbacks.
   ========================================================= */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var cartCountBadges = function () {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]'));
  };

  /* ----------- toast ----------- */
  function emitCartAdded(qty) {
    try { document.dispatchEvent(new CustomEvent('shx:cart:added', { detail: { quantity: qty || 1 } })); } catch (e) {}
  }
  function toast(title, msg, type) {
    var wrap = document.querySelector('.toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'toast-wrap';
      wrap.setAttribute('aria-live', 'polite');
      document.body.appendChild(wrap);
    }
    var el = document.createElement('div');
    el.className = 'toast' + (type === 'err' ? ' err' : '');
    el.innerHTML =
      '<div class="ti">' + (type === 'err' ? '!' : '✓') + '</div>' +
      '<div><b>' + (title || '') + '</b><span>' + (msg || '') + '</span></div>';
    wrap.appendChild(el);
    setTimeout(function () {
      el.style.transition = 'all .3s';
      el.style.opacity = 0;
      el.style.transform = 'translateX(30px)';
    }, 2700);
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 3100);
  }
  window.shxToast = toast;

  /* ----------- Klaviyo: Added to Cart event push ----------- */
  function klaviyoTrackAddToCart(item) {
    try {
      var _learnq = window._learnq;
      if (!_learnq || !item) return;
      _learnq.push(['track', 'Added to Cart', {
        '$value': item.price * (item.quantity || 1),
        'AddedItemProductName': item.name || '',
        'AddedItemProductID': item.productId || '',
        'AddedItemSKU': item.sku || '',
        'AddedItemImageURL': item.image || '',
        'AddedItemURL': item.url || '',
        'AddedItemPrice': item.price || 0,
        'AddedItemQuantity': item.quantity || 1,
        'ItemNames': item.name ? [item.name] : []
      }]);
    } catch (e) { /* Klaviyo not loaded — safe fail */ }
  }

  /* ----------- Variant price map: page's own variant JSON → dollars ----------- */
  function extractBalancedJsonText(txt, start) {
    if (!txt || txt.charAt(start) !== '{') return '';
    var depth = 0, inStr = false, esc = false;
    for (var i = start; i < txt.length; i++) {
      var ch = txt.charAt(i);
      if (inStr) {
        if (esc) esc = false;
        else if (ch === '\\') esc = true;
        else if (ch === '"') inStr = false;
        continue;
      }
      if (ch === '"') inStr = true;
      else if (ch === '{') depth++;
      else if (ch === '}') { depth--; if (depth === 0) return txt.substring(start, i + 1); }
    }
    return '';
  }
  function getVariantPriceMap() {
    if (window.__shxVariantPriceMap) return window.__shxVariantPriceMap;
    var map = null;
    try {
      var scripts = document.getElementsByTagName('script');
      for (var i = 0; i < scripts.length && !map; i++) {
        var txt = scripts[i].textContent || '';
        var marker = 'var product = ';
        var m = txt.indexOf(marker);
        if (m === -1) continue;
        var prod = null;
        try { prod = JSON.parse(extractBalancedJsonText(txt, txt.indexOf('{', m))); } catch (eJson) {}
        if (!prod || !prod.variants || !prod.variants.length) continue;
        map = {};
        for (var vi = 0; vi < prod.variants.length; vi++) {
          var v = prod.variants[vi];
          if (v && v.id != null && typeof v.price === 'number' && v.price > 0) map[String(v.id)] = v.price / 100;
        }
        if (!Object.keys(map).length) map = null;
      }
    } catch (e) {}
    window.__shxVariantPriceMap = map;
    return map;
  }
  function getVariantTitleMap() {
    if (window.__shxVariantTitleMap) return window.__shxVariantTitleMap;
    var map = null;
    try {
      var scripts = document.getElementsByTagName('script');
      for (var i = 0; i < scripts.length && !map; i++) {
        var txt = scripts[i].textContent || '';
        var marker = 'var product = ';
        var m = txt.indexOf(marker);
        if (m === -1) continue;
        var prod = null;
        try { prod = JSON.parse(extractBalancedJsonText(txt, txt.indexOf('{', m))); } catch (eJson) {}
        if (!prod || !prod.variants || !prod.variants.length) continue;
        map = {};
        for (var vi = 0; vi < prod.variants.length; vi++) {
          var v = prod.variants[vi];
          if (v && v.id != null && typeof v.title === 'string' && v.title) map[String(v.id)] = v.title;
        }
        if (!Object.keys(map).length) map = null;
      }
    } catch (e) {}
    window.__shxVariantTitleMap = map;
    return map;
  }

  /* ----------- GA4 dataLayer: add_to_cart (from cart/add.js response) ----------- */
  function pickAddedLine(resBody) {
    if (!resBody || typeof resBody !== 'object' || resBody.pipe) return null;
    if (resBody.line_item && typeof resBody.line_item === 'object') return resBody.line_item;
    if (resBody.items && resBody.items.length) {
      if (resBody.key != null) {
        for (var i = 0; i < resBody.items.length; i++) {
          if (resBody.items[i] && String(resBody.items[i].key) === String(resBody.key)) return resBody.items[i];
        }
      }
      return resBody.items[0];
    }
    return null;
  }
  function dataLayerAddToCart(resBody, addedQty, ctx) {
    try {
      ctx = (ctx && typeof ctx === 'object') ? ctx : {};
      var body = (resBody && typeof resBody === 'object' && !resBody.pipe) ? resBody : {};
      var line = pickAddedLine(body);
      var qty = (typeof addedQty === 'number' && addedQty > 0) ? addedQty : (parseInt(body.quantity, 10) || 1);

      // variant id of the added line — page ctx (currently selected variant) first, then response
      var variantId = '';
      if (ctx.variantId != null) variantId = String(ctx.variantId);
      if (!variantId && line && line.variant_id != null) variantId = String(line.variant_id);
      if (!variantId && body.item_id != null) variantId = String(body.item_id);
      if (!variantId && ctx.productId != null) variantId = String(ctx.productId);

      // price in dollars — 1) page variant map  2) cart/add.js line (integer cents)  3) page ctx
      var price = 0;
      if (variantId) {
        var map = getVariantPriceMap();
        if (map && map[variantId] > 0) price = map[variantId];
      }
      if (!price && line) {
        var centFields = ['final_price', 'price', 'single_price', 'item_price', 'original_price'];
        for (var ci = 0; ci < centFields.length; ci++) {
          if (typeof line[centFields[ci]] === 'number' && line[centFields[ci]] > 0) { price = line[centFields[ci]] / 100; break; }
        }
      }
      if (!price && typeof ctx.price === 'number' && ctx.price > 0) price = ctx.price;

      // 4) still no price — do not push the event (never emit price=0)
      if (!(price > 0)) return;

      var currency = body.currency || (window.theme && window.theme.currency) || 'USD';
      var productName = ctx.name || (line && line.title) || body.title || '';
      // variant title — 1) page variant map by added variant id  2) page ctx (PDP select)  3) cart/add.js line
      var variantTitle = '';
      if (variantId) {
        var vmap = getVariantTitleMap();
        if (vmap && vmap[variantId]) variantTitle = vmap[variantId];
      }
      if (!variantTitle && ctx.variantTitle) variantTitle = ctx.variantTitle;
      if (!variantTitle && line && line.variant_title) variantTitle = line.variant_title;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        currency: currency,
        value: Math.round(price * qty * 100) / 100,
        items: [{
          item_id: variantId,
          item_variant: variantTitle,
          variant_id: variantId,
          item_name: productName,
          item_brand: (window.theme && window.theme.brand) || '',
          price: price,
          currency: currency,
          quantity: qty
        }]
      });
    } catch (e) { /* analytics must never break the cart */ }
  }
  window.shxDataLayerAddToCart = dataLayerAddToCart;

  /* ----------- Quick add from product card ----------- */
  window.shxQuickAdd = function (productId, variantId, btnEl) {
    if (!variantId || !routes.cart_add_url) {
      toast('Variant missing', 'Open the product page to choose options.', 'err');
      return;
    }
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    btnEl = btnEl || document.body;
    btnEl.setAttribute('disabled', 'disabled');
    var original = btnEl.innerHTML;
    btnEl.innerHTML = 'Adding…';

    fetch(routes.cart_add_url, {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/javascript, application/json' }
    })
      .then(function (r) {
        return r.text().then(function (t) {
          try { return JSON.parse(t); } catch (e) { return t; }
        }).then(function (body) { return { ok: r.ok, status: r.status, body: body }; });
      })
      .then(function (res) {
        btnEl.removeAttribute('disabled');
        btnEl.innerHTML = original;
        if (!res.ok) {
          var msg = (res.body && res.body.description) || (res.body && res.body.message) || 'Could not add to cart';
          toast('Oops', msg, 'err');
          // fallback — jump to product URL
          var card = btnEl.closest && btnEl.closest('.p-card');
          if (card && card.dataset.productUrl) {
            setTimeout(function () { window.location.href = card.dataset.productUrl; }, 900);
          }
          return;
        }
        // Sync count: if response has item_count, use it; else +1
        var plus = 1;
        var parsed = res.body || {};
        try {
          if (parsed && typeof parsed.item_count === 'number') {
            cartCountBadges().forEach(function (b) { b.textContent = String(parsed.item_count); b.style.display = 'grid'; });
            plus = 0;
          }
        } catch (_) {}
        if (plus) {
          cartCountBadges().forEach(function (b) {
            var n = (parseInt(b.textContent || '0', 10) || 0) + 1;
            b.textContent = String(n);
            b.style.display = 'grid';
          });
        }
        emitCartAdded(1);
        toast('Added to Cart', 'Review your items in the cart.', 'ok');

        /* GA4 dataLayer: add_to_cart (response first, card DOM as fallback) */
        var card = btnEl.closest ? btnEl.closest('.p-card') : null;
        var cardCtx = {};
        try {
          if (btnEl.dataset.variantId) cardCtx.variantId = btnEl.dataset.variantId;
          if (card) {
            if (card.dataset.productId) cardCtx.productId = card.dataset.productId;
            var qaNameEl = card.querySelector('.p-name');
            if (qaNameEl) cardCtx.name = qaNameEl.textContent.trim();
            var qaPriceEl = card.querySelector('.price');
            if (qaPriceEl) {
              var qaPriceNum = parseFloat(qaPriceEl.textContent.replace(/[^\d.]/g, ''));
              if (qaPriceNum > 0) cardCtx.price = qaPriceNum;
            }
          }
        } catch (eCtx) { /* ctx is best-effort */ }
        dataLayerAddToCart(parsed, 1, cardCtx);

        /* Klaviyo: Added to Cart */
        if (card) {
          klaviyoTrackAddToCart({
            productId: card.dataset.productId || '',
            sku: card.dataset.sku || '',
            name: card.dataset.productTitle || card.querySelector('.p-title') ? (card.querySelector('.p-title')||{}).textContent : '',
            image: card.dataset.productImage || '',
            url: card.dataset.productUrl || '',
            price: parseFloat((card.dataset.productPrice || '0').replace(/[^0-9.]/g, '')) || 0,
            quantity: 1
          });
        }
      })
      .catch(function () {
        btnEl.removeAttribute('disabled');
        btnEl.innerHTML = original;
        toast('Network error', 'Please try again in a moment.', 'err');
      });
  };

  /* ----------- Cart count live sync using cart.js ----------- */
  function syncCartCount() {
    if (!routes.root_url) return;
    fetch((routes.root_url.replace(/\/$/, '') || '') + '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { if (r.ok) return r.json(); }).then(function (c) {
      if (c && typeof c.item_count === 'number') {
        cartCountBadges().forEach(function (b) {
          b.textContent = String(c.item_count);
          b.style.display = c.item_count > 0 ? 'grid' : 'none';
        });
      }
    }).catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartCount);
  } else {
    syncCartCount();
  }

  /* ----------- Product form: AJAX add to cart + Buy Now ----------- */
  function bindProductForms() {
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.classList || !form.classList.contains('product-form')) return;
      var isBuyNow = form.classList.contains('buy-now');
      var submitBtn = form.querySelector('button[type="submit"][name="add"]');
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value || !routes.cart_add_url) return;
      if (isBuyNow) return; // native submit → Shopify buy now redirect
      ev.preventDefault();
      if (form.getAttribute('data-shx-adding') === '1') return; // already in flight: keep a single add path
      form.setAttribute('data-shx-adding', '1');
      var done = function () { form.removeAttribute('data-shx-adding'); };
      var data = new FormData(form);
      var qty = parseInt(data.get('quantity') || '1', 10) || 1;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.text = submitBtn.innerHTML; submitBtn.innerHTML = 'Adding…'; }
      fetch(routes.cart_add_url, {
        method: 'POST', body: data,
        headers: { Accept: 'application/json, application/javascript' }
      })
        .then(function (r) {
          return r.text().then(function (t) {
            try { return JSON.parse(t); } catch (e) { return t; }
          }).then(function (body) { return { ok: r.ok, body: body }; });
        })
        .then(function (res) {
          done();
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = submitBtn.dataset.text || 'Add to Cart'; }
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) || 'Could not add to cart.';
            toast('Oops', msg, 'err');
            form.submit();
            return;
          }
          if (res.body && typeof res.body.item_count === 'number') {
            cartCountBadges().forEach(function (b) {
              b.textContent = String(res.body.item_count);
              b.style.display = 'grid';
            });
          } else {
            cartCountBadges().forEach(function (b) {
              var n = (parseInt(b.textContent || '0', 10) || 0) + qty;
              b.textContent = String(n); b.style.display = 'grid';
            });
          }
          emitCartAdded(qty);
          toast('Added to Cart', 'Item added successfully.', 'ok');

          /* GA4 dataLayer: add_to_cart (response first, PDP DOM as fallback — reflects the currently selected variant) */
          var pdpCtx = {};
          try {
            if (idInput && idInput.value) pdpCtx.variantId = idInput.value;
            var pdpSel = document.getElementById('shx-variant');
            if (pdpSel && pdpSel.options && pdpSel.options[pdpSel.selectedIndex]) {
              pdpCtx.variantTitle = pdpSel.options[pdpSel.selectedIndex].textContent.trim();
            }
            var pdpH1 = document.querySelector('h1');
            if (pdpH1) pdpCtx.name = pdpH1.textContent.trim();
            var pdpPriceEl = document.querySelector('.shx-price-now');
            if (pdpPriceEl) {
              var pdpPriceNum = parseFloat(pdpPriceEl.textContent.replace(/[^\d.]/g, ''));
              if (pdpPriceNum > 0) pdpCtx.price = pdpPriceNum;
            }
          } catch (eCtx2) { /* ctx is best-effort */ }
          dataLayerAddToCart(res.body, qty, pdpCtx);

          /* Klaviyo: Added to Cart from PDP */
          klaviyoTrackAddToCart({
            productId: form.dataset.productId || '',
            sku: form.dataset.sku || (idInput.dataset.sku || ''),
            name: form.dataset.productTitle || (document.querySelector('h1.product-title')||{}).textContent || '',
            image: form.dataset.productImage || (document.querySelector('.product-main-image img')||{}).src || '',
            url: window.location.href,
            price: parseFloat(form.dataset.productPrice || '0') || 0,
            quantity: qty
          });
        })
        .catch(function () {
          done();
          if (submitBtn) { submitBtn.disabled = false; }
          form.submit();
        });
    });
  }
  bindProductForms();

  /* ----------- Mobile nav close on outside click ----------- */
  document.addEventListener && document.addEventListener('click', function (e) {
    var nav = document.getElementById('ShxNav');
    if (!nav || !nav.classList.contains('is-open')) return;
    var toggle = document.querySelector('.shx-mobile-toggle');
    if (!e.target.closest || (e.target.closest('#ShxNav') || e.target.closest('.shx-mobile-toggle'))) return;
    nav.classList.remove('is-open');
  });

  /* ----------- Price filter (collection) ----------- */
  document.addEventListener && document.addEventListener('DOMContentLoaded', function () {
    var min = document.getElementById('shx-price-min');
    var max = document.getElementById('shx-price-max');
    if (!min || !max) return;
    function rebuild() {
      // Filter rendered product cards by price on client side (best-effort).
      var lv = parseFloat(min.value) || -Infinity;
      var hv = parseFloat(max.value) || Infinity;
      var count = 0;
      document.querySelectorAll('.p-card').forEach(function (card) {
        var priceEl = card.querySelector('.price-item--regular, .now');
        if (!priceEl) { card.style.display = ''; count++; return; }
        var str = (priceEl.textContent || '').replace(/[^0-9.]/g, '');
        var n = parseFloat(str);
        var show = n >= lv && n <= hv;
        card.style.display = show ? '' : 'none';
        if (show) count++;
      });
      var cc = document.getElementById('shx-count');
      if (cc) cc.textContent = String(count);
    }
    [min, max].forEach(function (i) { i.addEventListener('input', rebuild); i.addEventListener('change', rebuild); });
  });

  /* ----------- Collection infinite scroll ----------- */
  function initCollectionInfiniteScroll() {
    var wrap = document.querySelector('[data-shx-collection-infinite]');
    if (!wrap) return;
    var grid = document.getElementById('shx-product-grid');
    var msg = wrap.querySelector('.msg');
    var nextUrl = (wrap.getAttribute('data-shx-next-url') || '').replace(/^\s+|\s+$/g, '');
    var loading = false;
    var done = false;
    var armed = false;
    var io = null;
    var scrollHandler = null;

    function setStatus(text, isLoading, showRetry) {
      if (!msg) return;
      msg.innerHTML = '';
      msg.className = 'msg' + (isLoading ? ' is-loading' : '');
      if (isLoading) {
        var sp = document.createElement('span');
        sp.className = 'spin';
        sp.setAttribute('aria-hidden', 'true');
        msg.appendChild(sp);
      }
      if (text) msg.appendChild(document.createTextNode(text));
      if (showRetry) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'retry';
        btn.textContent = 'Try again';
        msg.appendChild(btn);
      }
    }

    function buildFetchUrl(rawUrl) {
      var url;
      try { url = new URL(rawUrl, window.location.origin); }
      catch (e) { return ''; }
      try {
        var pageParams = new URLSearchParams(window.location.search);
        ['preview_theme_id', 'preview_theme_key', '_fd'].forEach(function (key) {
          if (pageParams.has(key)) url.searchParams.set(key, pageParams.get(key));
        });
      } catch (e) {}
      url.searchParams.set('section_id', wrap.getAttribute('data-shx-section-id') || 'main-collection-product-grid');
      return url.toString();
    }

    function readNextFromDoc(doc) {
      var found = '';
      var nextWrap = doc.querySelector('[data-shx-collection-infinite]');
      if (nextWrap) {
        found = (nextWrap.getAttribute('data-shx-next-url') || '').replace(/^\s+|\s+$/g, '');
      }
      if (!found) {
        var pager = doc.querySelector('.shx-pager');
        if (pager) {
          var anchors = pager.querySelectorAll('a[href]');
          for (var i = 0; i < anchors.length; i++) {
            var label = (anchors[i].textContent || '').replace(/^\s+|\s+$/g, '');
            if (label.indexOf('Next') === 0) { found = anchors[i].getAttribute('href') || ''; break; }
          }
        }
      }
      return found;
    }

    function trigger() {
      if (!loading && !done && nextUrl) loadNext();
    }

    function arm() {
      if (done || armed || !wrap) return;
      armed = true;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) trigger();
          });
        }, { rootMargin: '0px 0px 900px 0px', threshold: 0.01 });
        io.observe(wrap);
      }
      scrollHandler = function () {
        if (loading || done) return;
        var rect = wrap.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        if (rect.top - vh < 900) trigger();
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
      window.addEventListener('resize', scrollHandler, { passive: true });
      scrollHandler();
    }

    function disarm() {
      if (io) { try { io.disconnect(); } catch (e) {} io = null; }
      if (scrollHandler) {
        try {
          window.removeEventListener('scroll', scrollHandler, { passive: true });
          window.removeEventListener('resize', scrollHandler, { passive: true });
        } catch (e) {}
        scrollHandler = null;
      }
      armed = false;
    }

    function finishAll() {
      done = true;
      disarm();
      if (wrap) wrap.classList.add('is-done');
      setStatus('You\u2019ve reached the end of the list \u2014 all products are loaded.', false, false);
    }

    function showError() {
      setStatus('Couldn\u2019t load more products.', false, true);
    }

    function loadNext() {
      if (loading || done) return;
      if (!nextUrl) { finishAll(); return; }
      loading = true;
      setStatus('Loading more products\u2026', true, false);
      var url = buildFetchUrl(nextUrl);
      if (!url) {
        loading = false;
        disarm();
        showError();
        return;
      }
      fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var responseGrid = doc.getElementById('shx-product-grid');
          var cards = responseGrid ? Array.prototype.slice.call(responseGrid.querySelectorAll('.p-card')) : [];
          if (!cards.length && grid) {
            var sec = doc.querySelector('.shx-shop .products-grid');
            if (sec) cards = Array.prototype.slice.call(sec.querySelectorAll('.p-card'));
          }
          if (!cards.length) {
            if (!doc.querySelector('[data-shx-collection-infinite]')) {
              nextUrl = '';
              loading = false;
              finishAll();
              return;
            }
            throw new Error('no cards parsed');
          }
          nextUrl = readNextFromDoc(doc);
          wrap.setAttribute('data-shx-next-url', nextUrl || '');
          var frag = document.createDocumentFragment();
          cards.forEach(function (card) { frag.appendChild(card); });
          if (grid) grid.appendChild(frag);
          loading = false;
          if (!nextUrl) { finishAll(); return; }
          setStatus('', false, false);
          arm();
        })
        .catch(function () {
          loading = false;
          if (done) return;
          disarm();
          showError();
        });
    }

    if (wrap.addEventListener) {
      wrap.addEventListener('click', function (ev) {
        var target = ev.target;
        if (target && target.classList && target.classList.contains('retry')) loadNext();
      });
    }

    if (!nextUrl) {
      finishAll();
      return;
    }
    arm();
  }
  initCollectionInfiniteScroll();

  /* ----------- Utility: escape ----------- */
  window.ShxTheme = {
    toast: toast,
    quickAdd: window.shxQuickAdd,
    syncCartCount: syncCartCount
  };
})();
